import React, { Component } from 'react';
import FormSelect from 'react-select';
import FormInputText from '../_shared/forms/FormInputText';

class InvoiceFilter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="d-flex">
                <div>
                    <input
                        name="search"
                        type="text"
                        className="form-control"
                        value={this.props.search}
                        onChange={this.props.handleSearchInput}
                        placeholder="Search..."
                    />
                </div>
                <div style={{ width: '200px', marginLeft: '10px', marginRight: '10px' }}>
                    <FormSelect
                        options={this.props.options}
                        value={this.props.options.find(o => o.value === this.props.value)}
                        onChange={this.props.onChange}
                    />
                </div>
                <div>
                    <button className="btn btn-cw-primary" onClick={() => this.props.handleSearchClick()}>
                        Search
                    </button>
                </div>
            </div>
        );
    }
}

export default InvoiceFilter;
